import Cookies from 'js-cookie';

const StoreInLocalStorage = 0;
const StoreInCookie = 1;


export default class UserDataService {
    saveData(responseUserData) {
        if (responseUserData == null || !Array.isArray(responseUserData)) {
            return;
        }

        for (let i = 0; i < responseUserData.length; i++) {
            let userData = responseUserData[i];
            if (userData.storeIn === StoreInCookie) {
                this._saveCookieData(userData);
                this._removeLocalStorageData(userData);
            }
            else if (userData.storeIn === StoreInLocalStorage) {
                this._saveLocalStorageData(userData);
                this._removeCookieData(userData);
            }

        }
    }

    loadData(data) {
        if (!localStorage) return data;

        if (data.storeIn === StoreInLocalStorage)
            return this._loadLocalStorageData(data);

        return data;
    }

    _saveCookieData(userData) {
        for (let key in userData.data) {
            if (!userData.data.hasOwnProperty(key)) continue;
            Cookies.set(key, userData.data[key]);
        }
    }

    _removeCookieData(userData) {
        if (!Cookies) return;
        for (let key in userData.data) {
            if (!userData.data.hasOwnProperty(key)) continue;
            Cookies.remove(key);
        }
    }

    _saveLocalStorageData(userData) {
        if (!localStorage) return;

        for (let key in userData.data) {
            if (!userData.data.hasOwnProperty(key)) continue;
            localStorage.setItem(key, encodeURIComponent(userData.data[key]));
        }
    }

    _loadLocalStorageData(userData) {
        if (!localStorage) return userData;

        for (let key in userData.data) {
            if (!userData.data.hasOwnProperty(key)) continue;
            userData.data[key] = decodeURIComponent(localStorage.getItem(key));
        }
        return userData;
    }

    _removeLocalStorageData(userData) {
        if (!localStorage) return;
        for (let key in userData.data) {
            if (!userData.data.hasOwnProperty(key)) continue;
            localStorage.removeItem(key);
        }
    }
}
